import React from 'react';
import PropTypes from 'prop-types';
import Classes from '../Classes';

const Stand = ({
  className = '', data = []
}) => (
  data.length
    ? (
      <div data-testid="stand" className={`${Classes.stand.root} ${className}`.trim()}>
        <span className={Classes.marker} aria-hidden="true" />
        <span className={Classes.prefix}>Stand:</span>
        {data.map((stand) => <span key={stand.name} className={Classes.stand.standName}>{stand.name}</span>)}
      </div>
    )
    : null
);

Stand.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array
};

export default Stand;
